<ion-card class="app-content">
  <ion-card-header>
    <ion-toolbar>
      <!-- header icon -->
      <ion-icon slot="start" size="large" [src]="'monitor-account' | getIcon"></ion-icon>
      <!-- title -->
      <ion-title>Team di Teleconsulto</ion-title>
    </ion-toolbar>
  </ion-card-header>
  <ion-card-content>
    <ion-list *ngIf="teleconsultoList && teleconsultoList !== null">
      <ion-item button lines="none" *ngFor="let item of teleconsultoList.physiciansGroups"> 
        <ion-icon  (click)="openDetail(item)" slot="end" name="pencil-outline">
        </ion-icon>
        <ion-icon  (click)="delete(item)" slot="end" name="trash-outline">
        </ion-icon>
        <ion-label>{{item.groupName}}</ion-label>
        <ion-label *ngIf="item.isPartOf" class="app-label">Fai parte del gruppo</ion-label>
      </ion-item>
    </ion-list>
    <ion-label *ngIf="!teleconsultoList">Non sono presenti Team</ion-label>
    <ion-row style="justify-content:end">
    <ion-button (click)="addTeam()">
      <ion-icon slot="start" name="add-outline"></ion-icon>
     Aggiungi team
     </ion-button>
    </ion-row>
  </ion-card-content>
</ion-card>